/**
 * 数据深层复制
 * @file 数据深层复制
 * @author author-name(zq 15515876393)
 */

export function deepCopy(val){
    return JSON.parse(JSON.stringify(val))
}